import AdminPlanCommissions from 'components/Admin/AdminPlanCommissions/List/AdminPlanCommissions';

const AdminPlanCommissionsPageList = () => {
	return <AdminPlanCommissions />;
};

export default AdminPlanCommissionsPageList;
